import { IconThermometer } from '../../../../../../../assets/control-icons/icon-thermometer';
import { AvailableIcon } from '../../../../../../../types';

export const temperatureIcons = (isOn?: boolean): AvailableIcon[] => [
  {
    iconName: '',
    component: <IconThermometer isOn={isOn !== undefined ? isOn : true} />,
    oldIconName: 'DEVICE_ICON_23',
  },
];
